export const LUCI_AGENT_TABS = Object.freeze({
  STATUS: 'status',
  CONFIGURATION: 'configuration',
});

export const resolveLuciAgentTab = tab =>
  Object.values(LUCI_AGENT_TABS).includes(tab) ? tab : LUCI_AGENT_TABS.STATUS;

export const buildLuciAgentMenuItems = ({ t, accountScopedRoute }) => [
  {
    name: 'Luci Status',
    label: t('LUCI_AGENT.TABS.SUMMARY'),
    icon: 'i-lucide-activity',
    to: accountScopedRoute(
      'luci_agent_index',
      {},
      { tab: LUCI_AGENT_TABS.STATUS }
    ),
  },
  {
    name: 'Luci Configuration',
    label: t('LUCI_AGENT.TABS.CONFIGURATION'),
    icon: 'i-lucide-settings-2',
    to: accountScopedRoute(
      'luci_agent_index',
      {},
      { tab: LUCI_AGENT_TABS.CONFIGURATION }
    ),
  },
];
